import React from 'react'
import { Route, Routes } from 'react-router-dom'

import PageComponent from 'router/page-component'

const GuideTwoStepFaq = React.lazy(() => import('pages/dashboard/guide/two-step-verification/faq'))
const GuideTwoStepHelp = React.lazy(() => import('pages/dashboard/guide/two-step-verification/help'))
const GuideTwoStepSetup = React.lazy(() => import('pages/dashboard/guide/two-step-verification/help/setup'))
const GuideAuthenticatorApp = React.lazy(() => import('pages/dashboard/guide/two-step-verification/help/setup/authenticator-app'))
const GuideTwoStepSignIn = React.lazy(() => import('pages/dashboard/guide/two-step-verification/help/sign-in'))
const GuideTwoStepIntroduction = React.lazy(() => import('pages/dashboard/guide/two-step-verification/introduction'))
const GuideBaseLayout = React.lazy(() => import('pages/dashboard/guide/two-step-verification/layout'))

export default function GuideRoutes() {
  return (
    <Routes>
      <Route element={<GuideBaseLayout />}>
        <Route
          path='/two-step-verification/introduction'
          element={<PageComponent component={<GuideTwoStepIntroduction />} name='GuideTwoStepIntroduction' />}
        />
        <Route
          path='/two-step-verification/help'
          element={<PageComponent component={<GuideTwoStepHelp />} name='GuideTwoStepHelp' />}
        />
        <Route
          path='/two-step-verification/faq'
          element={<PageComponent component={<GuideTwoStepFaq />} name='GuideTwoStepFaq' />}
        />
        <Route
          path='/two-step-verification/help/setup'
          element={<PageComponent component={<GuideTwoStepSetup />} name='GuideTwoStepSetup' />}
        />
        <Route
          path='/two-step-verification/help/setup/authenticator-app'
          element={<PageComponent component={<GuideAuthenticatorApp />} name='GuideAuthenticatorApp' />}
        />
        <Route
          path='/two-step-verification/help/sign-in'
          element={<PageComponent component={<GuideTwoStepSignIn />} name='GuideTwoStepSignIn' />}
        />
      </Route>
    </Routes>
  )
}
